module.exports = "/assets/c96548e89c9ce5fbc87a3599fa9a604c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/WT.png
// module id = 3091
// module chunks = 0